import FormSelectInput from "./FormSelectInput";

const FormSelectSyncTasks = (props) => {
    const loadOptions = async (input) => {
        return [
            { value: 'CUSTOMER', label: 'Customer' },
            { value: 'TIME', label: 'Time' },
            { value: 'EMPLOYEE', label: 'Employee' },
            { value: 'PAYROLL_ITEM', label: 'Payroll Items' },
        ]
    }

    return (
        <FormSelectInput loadOptions={loadOptions} {...props} isMulti />
    )
}

export default FormSelectSyncTasks;